export default __webpack_public_path__ + "images/SpeakersPhotos/Jaime Castillo_Shakers.jpg?72bc83b1";